import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
// import { Panel, PanelGroup } from 'react-bootstrap';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import HeaderBack from 'components/components/account/components/HeaderBack';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';


class Faq extends React.Component {

  render() {
    const general = TransHelper.translate(
      this.props.locale, "content.landing.faq.generalQuestions"
    );
    const payment = TransHelper.translate(
      this.props.locale, "content.landing.faq.paymentQuestions"
    );
    const account = TransHelper.translate(
      this.props.locale, "content.landing.faq.accountQuestions"
    );
    const { isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text">
        {isLogged &&
          <HeaderBack
            locale={this.props.locale}
            name="content.layout.sidebarAndHeader.help"
            link="routes.url.help"
            title="content.layout.sidebarAndHeader.backToHelpTitle"
            className="header-back--lp" />
        }

        <div className="row row--text">

          <div className="headline headline--subpage headline--faq">
            <h1><T>content.landing.faq.title</T></h1>
            {/* <h1>F<span>requently</span> a<span>sked</span> q<span>uestions</span></h1> */}
            <p><T>content.landing.faq.description</T></p>
          </div>

          <h4 className="text-center"><T>content.landing.faq.generalTitle</T></h4>

          <div className='wrapper'>
            <ul className='accordion-list'>
              {general.map((general, key) => {
                return (
                  <li {...{ className: 'accordion-list__item', key }}>
                    <AccordionItem {...general} />
                  </li>
                )
              })}
            </ul>
          </div>

          <h4 className="text-center"><T>content.landing.faq.paymentTitle</T></h4>

          <div className='wrapper'>
            <ul className='accordion-list' style={{ margin: '15px auto 55px' }}>
              {payment.map((payment, key) => {
                return (
                  <li {...{ className: 'accordion-list__item', key }}>
                    <AccordionItem {...payment} />
                  </li>
                )
              })}
            </ul>
          </div>

          <h4 className="text-center"><T>content.landing.faq.accountTitle</T></h4>

          <div className='wrapper'>
            <ul className='accordion-list' style={{ marginBottom: 0 }}>
              {account.map((accountValues, key) => {
                return (
                  <li {...{ className: 'accordion-list__item', key }}>
                    <AccordionItem {...accountValues} />
                  </li>
                )
              })}
            </ul>
          </div>

        </div>
      </div>
    )
  }
}

class AccordionItem extends React.Component {
  state = {
    opened: false
  }

  render() {
    const {
      props: { paragraph, title },
      state: { opened }
    } = this

    return (
      <div
        {...{
          className: `accordion-item ${opened && 'accordion-item--opened'}`,
          onClick: () => { this.setState({ opened: !opened }) }
        }}
      >
        <div className='accordion-item__line'>
          <h4 className='accordion-item__title'>
            {title}
          </h4>
          <span className='accordion-item__icon' />
        </div>
        <div className='accordion-item__inner'>
          <div className='accordion-item__content'>
            <p className='accordion-item__paragraph'>

            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(Faq));
